import { useResolve } from '@visiba/instantiation';
import { useConstant } from '@visiba/react-std';
import { createContext, ReactNode, useContext } from 'react';
import { AnalyticCategories, AnalyticService } from './analytic.service';

const Context = createContext(AnalyticCategories.Unset);

interface Props {
	category: AnalyticCategories;
	children: ReactNode;
}

export function AnalyticProvider({ children, category }: Props): JSX.Element {
	return <Context.Provider value={category}>{children}</Context.Provider>;
}

export function useAnalyticContext() {
	const category = useContext(Context);
	const analyticService = useResolve(AnalyticService);

	const obj = useConstant(() => {
		return {
			service: analyticService,
			category,
			trackEvent(action: string, name?: string) {
				analyticService.trackEvent(category, action, name);
			},
		} as const;
	});

	return obj;
}
